import NiceModal from '@ebay/nice-modal-react'
import AuditModalV2 from './AuditModalV2'

export default NiceModal.create(AuditModalV2)
